import { createContext, useContext } from 'react';
import { FeedbackProps } from './FeedbackProvider';

type ContextType = {
  showFeedback: (props: FeedbackProps) => void;
};

//@ts-ignore
export const FeedbackContext = createContext<ContextType>(null);

/**
 * @summary Использует конекст FeedbackProvider-а и возвращает объект,
 * внутри которого есть фукнция showFeedback - она вызывает фидбэк.
 */
export const useFeedback = () => useContext(FeedbackContext);
